import { METERS } from "@/data/tunables";
import type { GameState } from "@/state/GameState";

/**
 * The meter warning bands — a LEAF module (tunables + state types only)
 * so both the meters system and the RunMeta machine can share the same
 * predicates without a cycle (v0.10 M4).
 */

/** Heat sits in the pre-shutdown warning band (HUD danger tell + offline nudge). */
export function heatDanger(state: GameState): boolean {
  return state.run.heat >= METERS.hotThreshold;
}

/** DEA sits in the pre-raid warning band — only meaningful once criminal is live. */
export function deaDanger(state: GameState): boolean {
  return state.run.criminal.unlocked && state.run.dea >= METERS.deaCeiling * 0.7;
}
